import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowLeft as fasArrowLeft,
  faSpinnerThird,
} from '@fortawesome/pro-solid-svg-icons'
import { faExclamationCircle as farExclamationCircle } from '@fortawesome/pro-regular-svg-icons'
import {
  faBan as falBan,
  faBoxCheck as falBoxCheck,
  faBoxFull as falBoxFull,
  faBoxHeart as falBoxHeart,
  faBoxOpen as falBoxOpen,
  faBuilding as falBuilding,
  faCalendarCheck as falCalendarCheck,
  faCalendarDay as falCalendarDay,
  faCarSide as falCarSide,
  faCheckCircle as falCheckCircle,
  faClock as falClock,
  faCommentAltLines as falCommentAltLines,
  faCreditCard as falCreditCard,
  faDoorClosed as falDoorClosed,
  faExclamationTriangle as falExclamationTriangle,
  faExternalLink as falExternalLink,
  faGift as falGift,
  faIdCard as falIdCard,
  faLink as falLink,
  faMapMarker as falMapMarker,
  faMapMarkerAlt as falMapMarkerAlt,
  faMapMarkerCheck as falMapMarkerCheck,
  faMapMarkerSmile as falMapMarkerSmile,
  faPersonCarry as falPersonCarry,
  faPersonDolly as falPersonDolly,
  faShippingFast as falShippingFast,
  faShoppingBag as falShoppingBag,
  faShoppingBasket as falShoppingBasket,
  faSpinnerThird as falSpinnerThird,
  faStore as falStore,
  faTags as falTags,
  faTruck as falTruck,
  faTruckLoading as falTruckLoading,
  faUserCircle as falUserCircle,
} from '@fortawesome/pro-light-svg-icons'
import {
  faCcAmex,
  faCcMastercard,
  faCcVisa,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faCcAmex,
  faCcMastercard,
  faCcVisa,
  falBan,
  falBoxCheck,
  falBoxFull,
  falBoxHeart,
  falBoxOpen,
  falBuilding,
  falCalendarCheck,
  falCalendarDay,
  falCarSide,
  falCheckCircle,
  falClock,
  falCommentAltLines,
  falCreditCard,
  falDoorClosed,
  falExclamationTriangle,
  falExternalLink,
  falGift,
  falIdCard,
  falLink,
  falMapMarker,
  falMapMarkerAlt,
  falMapMarkerCheck,
  falMapMarkerSmile,
  falPersonCarry,
  falPersonDolly,
  falShippingFast,
  falShoppingBag,
  falShoppingBasket,
  falSpinnerThird,
  falStore,
  falTags,
  falTruck,
  falTruckLoading,
  falUserCircle,
  farExclamationCircle,
  fasArrowLeft,
  faSpinnerThird
) // Use any icon from the Solid style
